module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("The Statement of Harrison Smith")])])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I first met Tarl Cabot at a small liberal arts college in New Hampshire, where we had both accepted first-year teaching appointments. He was an instructor in English history and I, intending to work for some three years to save money toward law school, had accepted an appointment as an instructor in physical education, a field which, to my annoyance, Cabot never convinced himself belonged in the curriculum of an educational institution.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("We hiked a good deal, talked and fenced, and, I hoped, had become friends. I liked the young, gentle Englishman. He was quiet and pleasant, though sometimes he seemed remote, or lonely, somehow unwilling to break through that protective shield of formality behind which the educated Englishman, at heart perhaps as sentimental and hot-blooded as any man, attempts to conceal his feelings.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Young Cabot was rather tall, a good-sized man, well-built, with an animal ease in his walk that perhaps bespoke the docks of Bristol, his native city, rather than the cloisters of Oxford, at one of whose colleges he had obtained his later education. His eyes were clear, and blue, direct and honest. He was fairly complected. His hair, lamentably perhaps, though some of us loved him for it, was red, but not merely red—it was rather a tangled, blazing affront to the proprieties of the well-groomed academician. I doubt that he owned a comb, and I would be willing to swear that he would not have used one if he had. All in all, Tarl Cabot seemed to us a young, quiet, courteous Oxford gentleman, except for that hair. And then we weren't sure.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("To my consternation and that of the college, Cabot disappeared shortly after the conclusion of the first semester. I am sure that this was not of his own intention. Cabot is a man who honors his commitments.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("At the end of the semester, Cabot, like the rest of us, was weary of the academic routine, and was seeking some diversion. He decided to go camping—by himself—in the nearby White Mountains, which were very beautiful then, in the white, brittle splendor of a New Hampshire February.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I loaned him some of my camping gear and drove him into the mountains, dropping him off beside the highway. He asked me, and I am certain he was serious, to meet him at the same place in three days. I returned at the determined time, but he failed to keep the rendezvous. I waited several hours, and then returned at the same time the next day. Still he did not appear. Accordingly, then alarmed, I notified the authorities, and, by afternoon, a large-scale search was underway.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Eventually we found what we supposed to be the ashes of his fire, near a large flat rock some nine hours' climb from the highway. Our search, otherwise, was fruitless. Yet, several months later, I understand that Tarl Cabot stumbled out of these same mountains, alive and well, but apparently under the stress of some emotional shock which had culminated in amnesia—at least for that period during which he had been missing.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He never returned to teach at the college, to the relief of several of my elder colleagues, who now confessed that they had thought that young Cabot had never really fitted in. Shortly thereafter I determined that I did not fit in either, and left the college. I did receive a check from Cabot to cover the cost of my camping equipment, which he had apparently lost. It was a thoughtful gesture but I wish instead that he had stopped to see me. I would have seized his hand and forced him to speak to me, to tell me what had happened.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Somehow, unlike my colleagues at the school, I had found the amnesia account too simple. It was not an adequate explanation; it couldn't be. How had he lived for those months, where had he been, what had he done?")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It was almost seven years after I had known Tarl Cabot at the college when I saw him on the streets of Manhattan. By that time I had long ago saved the money I needed for law school and had not taught for three years. Indeed, I was then completing my studies at the school of law associated with one of New York's best-known private universities.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He had changed very little, if at all. I rushed over to him and without thinking seized him by the shoulder. What happened next seemed almost too unbelievable to comprehend. He spun like a tiger with a sudden cry of rage in some strange tongue and I found myself seized in hands like steel and with great force hurled helplessly across his knee, my spine an inch from being splintered like kindling wood.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In an instant he released me, apologizing profusely even before recognizing me. In horror I realized that what he had done had been as much a reflex as the blinking of an eye or the jerking of a knee under a physician's hammer. It was the reflex of an animal whose instinct it is to destroy before it can be destroyed, or of a human being who has been tooled into such an animal, a human being who has been conditioned to kill swiftly, savagely, or be killed in the same fashion. I was covered with sweat. I knew that I had been an instant from death. Was this the gentle Cabot I had known?")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Harrison!\" he cried. \"Harrison Smith!\" He lifted me easily to my feet, his words rapid and stumbling, trying to reassure me. \"I'm sorry,\" he kept saying, \"Forgive me! Forgive me, Old Man!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("We looked at one another.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He thrust out his hand impulsively, apologetically. I took it and we shook hands. I'm afraid my grip was a bit weak, and that my hand shook a little. \"I'm really frightfully sorry,\" he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There was a knot of people who had gathered, standing a safe distance away on the sidewalk.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He smiled, the old ingenuous boyish smile I remembered from New Hampshire. \"Would you like a drink?\" he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I smiled, too. \"I could use one,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In a small bar in midtown Manhattan, little more than a doorway and a corridor, Tarl Cabot and I renewed our friendship. We talked of dozens of things, but neither of us mentioned his abrupt response to my greeting, nor did we speak of those mysterious months in which he had disappeared in the mountains of New Hampshire.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In the ensuing months, my studies permitting, we saw one another fairly often. I seemed to answer a desperate need for human fellowship in that lonely man, and, for my part, I was more than happy to count myself his friend, unfortunately perhaps, his only friend.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I felt that the time would come when Cabot would speak to me of the mountains but that he himself would have to choose that time. I was not eager to intrude into his affairs, or his secrets, as the case might be. It was enough to be once more his friend. I wondered upon occasion why Cabot did not speak to me more openly on certain matters, why he so jealously guarded the mystery of those months in which he had been absent from the college. I now know why he did not speak sooner. He feared I would have thought him mad.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It was late one night, in early February, and we were drinking once more at that small bar in which we had had our first drink that incredible sunny afternoon some months before. Outside there was a light snow falling, soft as colored felt in the lonely neon lights of the street. Cabot watched it, between swallows of Scotch. He seemed to be morose, moody. I recalled it was in February that he had departed from the college, years earlier.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Perhaps we had better go home,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cabot continued to stare out the window, watching the neon snow drifting aimlessly down to the gray, trampled sidewalk.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I love her,\" said Cabot, not really speaking to me.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Who?\" I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He shook his head, and continued to watch the snow.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Let's go home,\" I said. \"It's late.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Where is home?\" asked Cabot, staring into the half-filled glass.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Your apartment, a few blocks from here,\" I said, wanting him to leave, wanting to get him out of there. His mood was alien to anything I had seen in him before. Somehow I was frightened.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He would not be moved. He pulled his arm away from my hand. \"It is late,\" he said, seeming to agree with me but intending perhaps more. \"It must not be too late,\" he said, as though he had resolved on something, as though by the sheer force of his will he would stop the flow of time, the random track of events.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I leaned back in my chair. Cabot would leave when he was ready. Not before. I became aware of his silence, and the light subdued patter of conversation at the bar, the clink of glasses, the sounds of a foot scraping, of liquid swirling into a small, heavy glass.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cabot lifted his Scotch again, holding it before him, not drinking. Then, ceremoniously, bitterly, he poured a bit of it out onto the table, where it splattered, partly soaking into a napkin. As he performed this gesture, he uttered some formula in that strange tongue I had heard but once before—when I had nearly perished at his hands. Somehow I had the feeling that he was becoming dangerous. I was uneasy.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"What are you doing?\" I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am offering a libation,\" he said. \"Ta-Sardar-Gor.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"What does that mean?\" I asked, my words fumbling a bit, blurred by the liquor, made unsteady by my fear.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It means,\" laughed Cabot, a mirthless laugh, \"—to the Priest-Kings of Gor!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He rose unsteadily. He seemed tall, strange, almost of another world in that subdued light, in that quiet atmosphere of small, genial civilized noises.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Then without warning, with a bitter laugh, at once a lament and a cry of rage, he hurled the glass violently to the wall. It shattered into a million sporadic gleaming fragments, shocking the place into a moment of supreme silence. And in that sudden instant of startled, awe-struck silence, I heard him clearly, intensely, repeat in a hoarse whisper that strange phrase, \"Ta-Sardar-Gor!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The bartender, a heavy, soft-faced man, waddled to the table. One of his fat hands nervously clutched a short leather truncheon, weighted with shot. The bartender jerked his thumb toward the door. He repeated the gesture. Cabot towering over him seemed not to comprehend. The bartender lifted the truncheon in a menacing gesture. Cabot simply took the weapon, seeming to draw it easily from the startled grip of the fat man. He looked down into the sweating, frightened fat face.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You have lifted a weapon against me,\" he said. \"My codes permit me to kill you.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The bartender and I watched with terror as Cabot's large firm hands twisted the truncheon apart, splitting the stitching, much as I might have twisted apart a roll of cardboard. Some of the shot dropped to the floor and rolled under the tables.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"He's drunk,\" I said to the bartender. I took Cabot firmly by the arm. He didn't seem to be angry any longer, and I could see that he intended no one any harm. My touch seemed to snap him out of his strange mood. He handed the ruined truncheon meekly back to the bartender.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I'm sorry,\" said Cabot. \"Really.\" He reached into his wallet and pressed a bill into the bartender's hands. It was a hundred-dollar bill.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("We put on our coats and went out into the February evening, into the light snow.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Outside the bar we stood in the snow, not speaking. Cabot, still half-drunk, looked about himself, at the brutal electric geometry of that great city, at the dark, lonely shapes that moved through the light snow, at the pale glimmering headlights of the cars.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"This is a great city,\" said Cabot, \"and yet it is not loved. How many are there here who would die for this city? How many who would defend to the death its perimeters? How many who would submit to torture on its behalf?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You're drunk,\" I said, smiling.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"This city is not loved,\" he said. \"Or it would not be used as it is, kept as it is.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He walked sadly away.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Somehow I knew that this was the night on which I would learn the secret of Tarl Cabot.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Wait!\" I cried to him suddenly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He turned and I sensed that he was glad that I had called to him, that my company on that night meant a great deal to him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I joined him and together we went to his apartment. First he brewed a pot of strong coffee, an act for which my swirling senses were more than grateful. Then without speaking he went into his closet and emerged carrying a strongbox. He unlocked this with a key which he carried on his own person, and removed a manuscript, written in his own clear, decisive hand and bound with twine. He placed the manuscript in my hands.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It was a document pertaining to what Cabot called the Counter-Earth, the story of a warrior, of the siege of a city, and of the love of a girl. You perhaps know it as "), _c('i', [_vm._v("Tarnsman of Gor")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("When, shortly after dawn, I had finished the account, I looked at Cabot, who, all the time, had been sitting at the window, his chin on his hands, watching the snow, lost in what thoughts I could scarce conjecture.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He turned and faced me.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It's true,\" he said, \"but you need not believe it.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I didn't know what to say. It could not, of course, be true, yet I felt Cabot to be one of the most honest men I had ever known.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Then I noticed his ring, almost for the first time, though I had seen it a thousand times. It had been mentioned in the account, that simple ring of red metal, bearing the crest of Cabot.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" said Cabot, extending his hand, \"this is the ring.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I gestured to the manuscript. \"Why have you shown me this?\" I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I want someone to know of these things,\" said Cabot simply.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I arose, now conscious for the first time of a lost night of sleep, the effects of the drinking, and of the several cups of bitter coffee. I smiled wryly. \"I think,\" I said, \"I'd better go.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Of course,\" said Cabot, helping me on with my coat. At the doorway he held out his hand. \"Good-bye,\" he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I'll see you tomorrow,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No,\" he said. \"I am going again to the mountains.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It was in February, at this time, that he had disappeared seven years before.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I was shocked into clear consciousness. \"Don't go,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am going,\" he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Let me come with you,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No,\" he said, \"I may not come back.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("We shook hands, and I had the strange feeling that I might never see Tarl Cabot again. My hand was clenched firmly on his, and his on mine. I had meant something to him, and he to me, and now as simply as this it seemed that friends might part forever, never to see or talk to one another again.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I found myself in the bleak white hallway outside his apartment, blinking at the exposed bulb in the ceiling. I walked for some hours, in spite of my fatigue, thinking, puzzling about these strange things of which I had heard.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Then suddenly I turned and, literally, ran back to his apartment. I had left him, my friend. To what I had no idea. I rushed to the door of the apartment and pounded on it with my fists. There was no answer. I kicked in the door, splintering the lock from the jamb. I entered the apartment. Tarl Cabot was gone!")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("On the table in that small furnished apartment was the manuscript I had read through the long night—with an envelope fastened under the twine. The envelope bore my name and address. Inside was the simple note: \"For Harrison Smith, should he care to have it.\" Dismal, I left the apartment, carrying the manuscript which was subsequently published as "), _c('i', [_vm._v("Tarnsman of Gor")]), _vm._v(". That and memory were all that I retained of my friend, Tarl Cabot.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("My examinations came and were successfully completed. Later, following another examination, I was admitted to the bar in New York State, and I entered one of the immense law offices in the city, hoping to obtain eventually enough experience and capital to open a small practice of my own. In the rush of working, in the interminable, demanding jungle of detail required in my trade, the memory of Cabot was forced from my mind. There is perhaps little more to say here, other than the fact that I have not seen him again. Though I have reason to believe he lives.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Late one afternoon, after work, I returned to my apartment. There—in spite of the locked doors and windows—on a coffee table before the settee, was a second manuscript, that which now follows. There was no note, no explanation.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Perhaps, as Tarl Cabot once remarked, \"The agents of the Priest-Kings are among us.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-239d4be0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section3.vue
// module id = 72
// module chunks = 0